import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/gcstudent/heroSection/HeroSection.css";

const SLIDES = [
  require("../../../assets/images/clgpic.jpg"),
  require("../../../assets/images/lib7.jpg"),
  require("../../../assets/images/lib8.jpg"),
];

const HeroSection = () => {
  const [current, setCurrent] = useState(0);
  const [fading, setFading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % SLIDES.length);
        setFading(false);
      }, 350);
    }, 3200);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="gcStudentHero">
      <div className="gcStudentHero__container">

        {/* LEFT CONTENT */}
        <div className="gcStudentHero__content">

          {/* BADGE */}
          <div className="gcStudentHero__badgeWrapper">

            {/* Rotating box behind badge */}
            <div className="gcStudentHero__rotatingBox" />

            <div className="gcStudentHero__badge">
              {/* Book SVG Icon */}
              <span className="gcStudentHero__badgeIcon">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                  <path d="M4 4.5A2.5 2.5 0 016.5 2H20v16H6.5A2.5 2.5 0 004 20.5v-16z" stroke="#0d7f96" strokeWidth="1.8" strokeLinejoin="round"/>
                  <path d="M20 18H6.5A2.5 2.5 0 004 20.5V21h16v-3z" stroke="#0d7f96" strokeWidth="1.8" strokeLinejoin="round"/>
                  <path d="M9 7h7M9 11h5" stroke="#0d7f96" strokeWidth="1.8" strokeLinecap="round"/>
                </svg>
              </span>
              Welcome to Excellence
            </div>
          </div>

          <h1 className="gcStudentHero__title">
            Your Gateway To
            <br />
            <span>Digital Knowledge</span>
          </h1>

          <p className="gcStudentHero__desc">
            Access thousands of books, PDFs, research papers and study notes.
            Learn smarter, faster and from anywhere.
          </p>

          <div className="gcStudentHero__buttons">
            <button className="gcStudentHero__btnPrimary" onClick={() => navigate("/library")}>
               Explore Library
           </button>
          <button className="gcStudentHero__btnSecondary" onClick={() => navigate("/about")}>Learn More</button>
          </div>

        </div>

        {/* RIGHT IMAGE */}
        <div className="gcStudentHero__imageWrapper">
          <div className="gcStudentHero__imageFrame">
            <div className="gcStudentHero__imageInner">
              <img
                src={SLIDES[current]}
                alt="Library"
                className={`gcStudentHero__image${fading ? " gcStudentHero__image--fade" : ""}`}
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default HeroSection;